import doctorImg from "../images/headerImg.png";
import dotsImg from "../images/doubts.png";
import section2 from "../images/Section2.png";
import injectionsImg from "../images/section4.png";
import tabletsImg from "../images/section3.png";
import onlineTrainImg from "../images/onlinetrain.png";
import didYouKnowImg from "../images/didYouKnowImg.png";
import Form from "../components/form";

// ====== Section 3: Online programmes cards config ======
const programmes = [
  {
    title: "Injections",
    img: injectionsImg,
    alt: "Injections",
    description:
      "Lorem ipsum dolor sit amet consectetur. Diam sed rhoncus orci vel amet sed at. Enim et elit donec nibh ornare mauris pulvinar nec ut.",
  },
  {
    title: "Tablets",
    img: tabletsImg,
    alt: "Tablets",
    description:
      "Lorem ipsum dolor sit amet consectetur. Diam sed rhoncus orci vel amet sed at. Enim et elit donec nibh ornare mauris pulvinar nec ut.",
  },
  {
    title: "Online train",
    img: onlineTrainImg,
    alt: "Online train",
    description:
      "Lorem ipsum dolor sit amet consectetur. Diam sed rhoncus orci vel amet sed at. Enim et elit donec nibh ornare mauris pulvinar nec ut.",
  },
];

const AboutUs = () => {
  return (
    <> 
      <section className="bg-white py-20 font-poppins">
        <img
          src={dotsImg}
          alt="dots"
          className="absolute left-0 top-[75px] w-16 sm:w-20 opacity-80 pointer-events-none select-none"
        />
        <div className=" relative max-w-7xl mx-auto px-2 sm:px-2 font-poppins">
         

          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <h1  className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[26px] sm:text-[30px] md:text-[38px] lg:text-[55px] mb-6">
                About Us
              </h1>

              <p className="text-[#556987] text-[16px] leading-relaxed mb-4">
                Hi, My name is Dr. Aasim, and I am a Weight Loss Specialist
                Doctor.
              </p>

             <p className="text-[#556987] text-[16px] leading-relaxed mb-4">
                My team and I are here to support you on your health journey.
              </p>

              <p className="text-[#556987] text-[16px] leading-relaxed mb-4">
                Please complete the brief assessment to book a free consultation
                with myself.
              </p>

           <p className="text-[#556987] text-[16px] leading-relaxed mb-4">
                This information will enable me to better understand your health
                history and needs to provide you with the best treatment plan
                during our consultation.
              </p>
            </div>

            <div className="flex justify-center">
              <img
                src={doctorImg}
                alt="Doctor"
                className="w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ============ Section 2: Full-width image =========== */}
      <img
        src={section2}
        alt="Section Image"
        className="w-full h-auto object-cover"
      />

      {/* ============ Section 3: Programmes Cards =========== */}
      <section className="bg-white py-16 font-poppins">
        <div className="max-w-7xl mx-auto px-2 font-poppins">
          <h2 className="text-center text-[48px] font-bold text-[#2A3342] leading-tight mb-10">
            Your online weight loss programmes
            <br />
            can include
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 font-poppins">
            {programmes.map((item) => (
              <div
                key={item.title}
                className="rounded shadow-md border border-slate-100 bg-white p-3"
              >
                <div className="bg-white rounded overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="w-full h-[20rem] object-cover"
                  />
                  <div className=" py-5">
                    <h3 className="text-[24px] font-bold text-[#111827] mb-2">
                      {item.title}
                    </h3>
                    <p className="text-[#374151] text-[16px] leading-relaxed px-2">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================ Section 4: Did you know ======================= */}
      <section className="bg-[#FAFAFA] py-20 font-poppins">
        <div className="max-w-7xl mx-auto px-1 font-poppins">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <h2 className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
             text-[26px] sm:text-[30px] md:text-[38px] lg:text-[48px] mb-6">
                Did you know
              </h2>

              <p className="text-[#556987] text-[16px] leading-relaxed mb-4">
                In a survey of 947 patients, The Obesity Management Association
                found that those following a medical weight loss programme lost
                9% of their body weight in just 12 weeks.
              </p>

              <p className="text-[#556987] text-[16px] leading-relaxed">
                Research shows that constant support through doctor consultations
                is the most effective approach to weight loss and produces the
                best results.
              </p>
            </div>

            <div className="flex justify-center md:justify-end">
              <img
                src={didYouKnowImg}
                alt="Doctor measuring waist"
                className="w-full object-cover rounded shadow-sm"
              />
            </div>
          </div>
        </div>
      </section>

      <Form />
    </>
  );
};

export default AboutUs;
